import React from "react";
import {
  ListItemText,
  ListItemIcon,
  ListItemButton,
  colors,
} from "@mui/material";
import { useLocation } from "react-router-dom";

import { NavigationLink } from "components/navigation-link";
import { isPathActive } from "../utils";

export function SidebarSubItem({ title, href, isExternal }) {
  const location = useLocation();
  const isActive = isPathActive(href, location.pathname);

  return (
    <NavigationLink href={href} isExternal={isExternal}>
      <ListItemButton
        style={{
          height: "36px",
          color: isActive ? colors.blue[500] : "#242424",
          userSelect: "none",
          verticalAlign: "middle",
          textDecoration: "none",
          display: "flex",
          flexGrow: "1",
          justifyContent: "flex-start",
          alignItems: "center",
          position: "relative",
          minWidth: "0",
          textAlign: "left",
          paddingTop: "8px",
          paddingBottom: "8px",
          paddingLeft: "24px",
          paddingRight: "16px",
        }}
      >
        <ListItemIcon />
        <ListItemText
          primary={title}
          primaryTypographyProps={{
            variant: "body2",
            style: { color: "inherit" },
          }}
        />
      </ListItemButton>
    </NavigationLink>
  );
}
